const capitalize = (str: string) => {
  const [firstLetter, ...rest] = str.trim();

  return `${firstLetter?.toUpperCase()}${rest.join('')}`;
};

export default capitalize;
